import React from "react";
import { api } from "@/lib/api";
import { useAttribution, nowISO } from "@/hooks/useAttribution";
import { useFormTimer } from "@/hooks/useFormTimer";
import Honeypot from "@/components/Honeypot";

export default function AffiliatePage() {
  const attribution = useAttribution();
  const { elapsedMs } = useFormTimer();
  const [hp, setHp] = React.useState("");
  const [form, setForm] = React.useState({ first_name:"", last_name:"", email:"", phone:"", company:"", audience:"" });
  const [done, setDone] = React.useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/affiliate/signup", {
        ...form,
        name: [form.first_name, form.last_name].filter(Boolean).join(" "),
        attribution,
        submitted_at: nowISO(),
        time_to_complete_ms: elapsedMs(),
        company_website_alt: hp,
      });
      setDone(true);
    } catch (err) {
      // Non-blocking — affiliate submission failure shouldn't break the page.
      void err;
    }
  };
  return (
    <main className="pt-32 pb-24">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="overline">Affiliate Program</div>
        <h1 className="font-display font-light text-5xl md:text-7xl mt-6 leading-[1.05]">Recurring revenue for the people who already trust you.</h1>
        <p className="text-secondary text-lg mt-8 max-w-2xl">Real estate agents, marketing agencies, IT consultants, coaches, and referral partners — earn recurring commissions for every Freedom By AI Design client you send our way.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12">
          <div className="editorial-card p-6"><div className="overline">Commission</div><div className="font-display text-3xl text-brand mt-3">25%</div><p className="text-secondary text-sm mt-2">Recurring, paid monthly</p></div>
          <div className="editorial-card p-6"><div className="overline">Cookie Window</div><div className="font-display text-3xl text-brand mt-3">90 Days</div></div>
          <div className="editorial-card p-6"><div className="overline">Payout</div><div className="font-display text-3xl text-brand mt-3">Net 30</div></div>
        </div>

        {done ? (
          <div className="mt-16 tracing-beam bg-surface p-12 border border-white/5">
            <div className="font-display text-3xl text-brand">You're in.</div>
            <p className="text-secondary mt-4">We'll send your affiliate link and onboarding within 24 hours.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-16 bg-surface p-10 border border-white/5 grid grid-cols-1 md:grid-cols-2 gap-6">
            <Honeypot value={hp} onChange={setHp}/>
            <input required placeholder="First Name *" className="input-line" value={form.first_name} onChange={(e)=>setForm({...form,first_name:e.target.value})} data-testid="aff-first-name"/>
            <input placeholder="Last Name" className="input-line" value={form.last_name} onChange={(e)=>setForm({...form,last_name:e.target.value})} data-testid="aff-last-name"/>
            <input required type="email" placeholder="Email *" className="input-line" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} data-testid="aff-email"/>
            <input placeholder="Phone" className="input-line" value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} data-testid="aff-phone"/>
            <input placeholder="Company" className="input-line" value={form.company} onChange={(e)=>setForm({...form,company:e.target.value})} data-testid="aff-company"/>
            <input placeholder="Audience size" className="input-line" value={form.audience} onChange={(e)=>setForm({...form,audience:e.target.value})} data-testid="aff-audience"/>
            <button type="submit" className="btn-primary md:col-span-2 w-fit" data-testid="aff-submit">Apply →</button>
          </form>
        )}
      </div>
    </main>
  );
}
